enum ActionTypes {
    OPEN_GLOBAL_SEARCH_POPUP = "globalSearch/openGlobalSearchPopup",
    CLOSE_GLOBAL_SEARCH_POPUP = "globalSearch/closeGlobalSearchPopup",
    SAVE_SEARCH_DATA = "globalSearch/saveSearchData",
    RESET = "globalSearch/reset"
}

export default ActionTypes;
